import { convertArrayToObject } from "Services/Entity/helper";
import { getActionType } from "Store/Shared/Actions/Helpers"
import ACTIONS from "./ActionTypes"

const initialState = {
    _isFetching: false,
    _forceFetch: true,
    ids: [],
    entities: {},
    byEntityId: {},
    byEntityIdByFieldId: {}
}

const settingsFieldsReducer = (
    state = initialState,
    { payload, type }: any
) => {
    switch (type) {
        case getActionType(ACTIONS.FETCH_FIELDS).REQUEST: {
            return {
                ...state,
                _forceFetch: false,
                _isFetching: true
            }
        }

        case getActionType(ACTIONS.FETCH_FIELDS).SUCCESS: {
            const { data } = payload;
            const ids: any = data.sort((a, b) => (a?.name < b?.name) ? -1 : (a?.name > b?.name) ? 1 : 0).map(({id}) => (id));
            const entities: any = convertArrayToObject(data, 'id');
            const byEntityId: any = {};
            const byEntityIdByFieldId: any = {};
            data.forEach((item: any) => {
                if (!byEntityId[item.entity_id]) byEntityId[item.entity_id] = [];
                if (!byEntityIdByFieldId[item.entity_id]) byEntityIdByFieldId[item.entity_id] = {};
                byEntityId[item.entity_id].push(item.id);
                byEntityIdByFieldId[item.entity_id][item.id] = item;
            });
            
            return {
                ...state,
                _isFetching: false,
                _forceFetch: false,
                ids,
                entities,
                byEntityId,
                byEntityIdByFieldId
            };
        }

        case getActionType(ACTIONS.FETCH_FIELDS).FAILURE: {
            return {
                ...state,
                _forceFetch: true,
                _isFetching: false
            }
        }

        default:
            return state;
    }
}

export default settingsFieldsReducer;